import React, { createContext, useContext, useMemo } from 'react'
import { createCapabilityOwner, EMPTY_ACCESS } from './capabilities'

const AccessContext = createContext(createCapabilityOwner(EMPTY_ACCESS))

export function AccessProvider({ access, children }) {
  const value = useMemo(() => createCapabilityOwner(access), [access])
  return <AccessContext.Provider value={value}>{children}</AccessContext.Provider>
}

export function useAccess() {
  return useContext(AccessContext)
}

export function CapabilityGate({ permission, anyOf, children, fallback = null }) {
  const access = useAccess()
  const allowed = permission ? access.hasPermission(permission) : access.canAny(anyOf || [])
  return allowed ? children : fallback
}
